import React from 'react';
import ReactDOM from 'react-dom';
import { poll } from '../utils/helpers';
import { isEmpty } from 'lodash-es';

const PickupItemStatus = ({ omsPickupMF, lineId }: { omsPickupMF: OMSPickupMF; lineId: number }) => {
  if (!omsPickupMF) return null;

  const statusBreakdown = omsPickupMF.lineLevelStatus.find((line) => line.shopifyLineItemId === lineId.toString())
    ?.statusBreakdown;
  if (!statusBreakdown) return null;

  const statusArray = statusBreakdown.map((breakdown) => breakdown.status);
  const readyForPickUp = statusArray.every((status) => status.toLowerCase() === 'ready_for_pickup');
  const allPickedUp = statusArray.every((status) => status.toLowerCase() === 'pickup_completed');
  const allCanceled = statusArray.every((status) => status.toLowerCase() === 'cancelled');
  const status = allPickedUp
    ? 'Picked Up'
    : allCanceled
    ? 'Canceled'
    : readyForPickUp
    ? 'Ready for Pickup'
    : 'In Process';

  return <p className={readyForPickUp || allPickedUp ? 'item-ready' : 'item-pending'}>{status}</p>;
};

const renderPickupStatusForOrderItems = () => {
  return () => {
    poll(() => !isEmpty(window.orders), 5000, 1000)
      .then((isPollingSuccessful) => {
        if (isPollingSuccessful && window.orders) {
          window.orders.forEach((order) => {
            order.lineItems.forEach((line) => {
              const mountNodes = document.querySelectorAll(`[react-render-target="order-${order.orderId}-${line.id}"]`);
              if (mountNodes && mountNodes.length > 0) {
                mountNodes.forEach((node) => {
                  ReactDOM.render(<PickupItemStatus omsPickupMF={order.omsPickupMF} lineId={line.id} />, node);
                });
              } else console.warn('missing render target for order item pickup status');
            });
          });
        }
      })
      .catch((err) => {
        console.warn('window.orders did not become available in time', err);
      });
  };
};
export const initPickupStatusForOrderItems = renderPickupStatusForOrderItems();

interface OMSPickupMF {
  shopifyOrderId: string;
  lastUpdatedTimestamp: string;
  lineLevelStatus: LineLevelStatus[];
}

interface LineLevelStatus {
  shopifyLineItemId: string;
  statusBreakdown: StatusBreakdown[];
}
interface StatusBreakdown {
  quantity: number;
  status: string;
}
